export const sidenavCollapsedWidth = 40
export const sidenavExpandedWidth = 232
export const sidenavBorderWidth = 1

export const sidenavCollapsedWidthPx = `${sidenavCollapsedWidth}px`
export const sidenavExpandedWidthPx = `${sidenavExpandedWidth}px`
